export function radixSort(arr: number[]) {
  const max: number = Math.max(...arr)
  let exp = 1
  let sortedArray = [...arr]
  while (Math.floor(max / exp) > 0) {
    sortedArray = countingSortByDigit(sortedArray, exp)
    exp *= 10
  }

  return sortedArray
}

function countingSortByDigit(arr: number[], exp: number) {
  const output: number[] = new Array(arr.length).fill(0)
  const count: number[] = new Array(10).fill(0)

  for (let i = 0; i < arr.length; i++) {
    const value = arr[i]!
    const digit: number = Math.floor(value / exp) % 10
    count[digit]!++
  }

  for (let i = 1; i < 10; i++) {
    count[i]! += count[i - 1]!
  }

  for (let i = arr.length - 1; i >= 0; i--) {
    const value = arr[i]!
    const digit: number = Math.floor(value / exp) % 10
    const countDigit = count[digit]!
    if (countDigit > 0) {
      const index = countDigit - 1
      output[index] = value
      count[digit]!--
    }
  }

  return output
}
